import { Font } from '../types/organisation'

export const stripHTML = (HTMLInput: string): string => {
  if (!HTMLInput) return ''
  const temporaryElement = document.createElement('div')
  temporaryElement.innerHTML = HTMLInput
  return temporaryElement.textContent || temporaryElement.innerText || ''
}

export const limitChars = (
  input: string,
  limit: number,
  ellipsis?: Boolean,
): string => {
  if (input.length > limit) {
    return `${input.substring(0, limit)}${ellipsis ? '...' : ''}`
  }
  return input
}

export const concatObjectValues = (
  object: Object,
  separator: string,
): string => {
  const result = Object.values(object).reduce((a, b) => a + separator + b)
  return result
}

export const createQueryString = (object: object): string => {
  const stripEmpty = Object.fromEntries(
    Object.entries(object).filter(([, value]) => value !== ''),
  )
  const searchParams = new URLSearchParams(stripEmpty)
  return searchParams.toString()
}

export const toSentenceCase = (string: string): string => string.charAt(0).toUpperCase()
  + string
    .slice(1)
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()

export const stripEmptyFromObject = (object: object): Object => Object.fromEntries(
  Object.entries(object).filter(
    ([, value]) => value !== '' && value !== undefined && value !== null && value !== ' ',
  ),
)

// want this to work with any array
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stripEmptyFromArray = (array: any[]): any[] => array.filter(
  (value) => value !== '' && value !== undefined && value !== null && value !== ' ',
)

export const onlyString = (input: string): string => input.replace(/[^a-zA-Z0-9]/g, '')

export const truncate = (input: string, limit: number): string => {
  if (input.length > limit) {
    return input.slice(0, limit).concat('...')
  }
  return input
}

// to ensure HTML codes like `&#163;` aren't escaped
export const parseString = (input: string | undefined): string => {
  const result = new DOMParser().parseFromString(
    `<!doctype html><body>${input}</body>`,
    'text/html',
  ).body.textContent || ''

  return result
}

export const capitalize = (string: string | undefined): string => (string && string[0] ? string[0].toUpperCase() + string.substring(1) : '')

export const sortAlphabeticallyByKey = <T>(
  a: T,
  b: T,
  key: keyof T,
): number => {
  if (a[key] < b[key]) return -1
  if (a[key] > b[key]) return 1
  return 0
}

export const getFont = (fontStyle: Font | undefined): string => {
  switch (fontStyle) {
    case Font.Serif:
      return '\'Noto Serif\', serif'
    case Font.SansSerif:
    default:
      return '\'Noto Sans\', sans-serif'
  }
}

export const addClasses = (...args: (string | false | undefined)[]): string => {
  const classes = args.filter((e) => e).join(' ')
  return classes
}

export const trueOr0 = (arg: unknown): boolean => Boolean(arg) || arg === 0

// Object.keys returns `string[]` instead of `(keyof T)[]` as you would expect.
// This is a workaround to get the correct type.
// eslint-disable-next-line no-type-assertion/no-type-assertion
export const getKeys = Object.keys as <T extends object>(
  object: T
) => Array<keyof T>
